"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDTH_PARAM = exports.QUALITY_PARAM = exports.IMAGE_FORMAT_PARAM = exports.IMAGE_BACKGROUND_PARAM = exports.HEIGHT_PARAM = exports.BACKGROUND_PARAM = void 0;
const BACKGROUND_PARAM = exports.BACKGROUND_PARAM = 'bc';
const IMAGE_BACKGROUND_PARAM = exports.IMAGE_BACKGROUND_PARAM = 'ib';
const HEIGHT_PARAM = exports.HEIGHT_PARAM = 'h';
const IMAGE_FORMAT_PARAM = exports.IMAGE_FORMAT_PARAM = 'imageFormat';
const QUALITY_PARAM = exports.QUALITY_PARAM = 'q';
const WIDTH_PARAM = exports.WIDTH_PARAM = 'w';
